import protoc from "../protoc/DataContent_pb.js"

// const baseURL = 'http://localhost:8080/'
const baseURL = 'https://204910013.xyz/'

//给服务发送信息，主要是已经定义好了action
//构建chatMsg
const chatMsgJson = (userId,talkId,msgContent,signFlag) => {
    const data = {
        userId,
        talkId,
        msgContent,
        signFlag,
    }
    return data
};
//构建DataContent
const dataContentJson = (action,chatMsg,extend) => {
    const data = {
        action,
        chatMsg,
        extend,
    }
    return data
};

const chatMsgProtoc = (userId,talkId,msgContent,signFlag) => {
    // 调用ChatMsgContent对象 实例化
    const chatMsg = new protoc.DataContent.ChatMsgContent()
    // 赋值
    chatMsg.setUserid(userId)
    chatMsg.setTalkid(talkId)
    chatMsg.setMsgcontent(msgContent)
    chatMsg.setSignflag(signFlag)
    return chatMsg
}

const dataContentProtocBytes = (action,chatMsg,extend) => {
    // 调用DataContent对象 实例化
    const dataContent = new protoc.DataContent();
    // 赋值
    dataContent.setAction(action)
    dataContent.setChatmsgcontent(chatMsg)
    dataContent.setExtend(extend)
    // 序列化
    const bytes = dataContent.serializeBinary();
    return bytes
}

// 反序列化
// var message2 = DataContent.DataContent().deserializeBinary(bytes)

export default {
    baseURL,
    chatMsgJson,
    dataContentJson,
    chatMsgProtoc,
    dataContentProtocBytes
}
